import { FONT_SIZES } from "@corca/data";
import "@tiptap/extension-text-style";
import { Mark, mergeAttributes } from "@tiptap/core";

import { isColor, mirrorColor } from "../utils/color";

import type { FontSize, Color } from "@corca/data";
import type { TextStyleOptions } from "@tiptap/extension-text-style";

export type TailwindAttributes = {
  color?: string;
  size?: string;
};

type TailwindTextStyleOptions = TextStyleOptions & TailwindAttributes;

export const TailwindTextStyle = Mark.create<TailwindTextStyleOptions>({
  name: "textStyle",

  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (element) => {
          const hasStyles = element.classList.length > 0;

          if (!hasStyles) {
            return false;
          }

          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML(element) {
          const matches = element.className.matchAll(/text-([a-z0-9-]+)/g);
          for (const match of matches) {
            if (!match[1].startsWith("size") && isColor(match[1])) {
              return match[1];
            }
          }
          return null;
        },
        renderHTML({ color }: { color?: Color }) {
          if (color) {
            return {
              class: `text-${color} dark:text-${mirrorColor(color)}`,
            };
          }

          return null;
        },
      },
      size: {
        default: null,
        parseHTML(element) {
          const match = element.className.match(/text-size-(\d+)/);
          if (match?.[1] && FONT_SIZES.includes(match[1] as FontSize)) {
            return match[1];
          }
          return null;
        },
        renderHTML({ size }: { size?: FontSize }) {
          if (size && FONT_SIZES.includes(size)) {
            return {
              class: `text-size-${size}`,
            };
          }
          return null;
        },
      },
    };
  },
});
